import { createClient } from "@supabase/supabase-js";

// DEAD SIMPLE: Just create the client
// Use placeholders during build/SSG to prevent "supabaseUrl is required" error
const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || 'placeholder';

if (supabaseUrl === 'https://placeholder.supabase.co') {
  console.warn("⚠️  WARNING: Supabase URL is missing! Using placeholder value. If you are seeing this in production, check your environment variables.");
}

const supabase = createClient(
  supabaseUrl,
  supabaseKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: "pkce",
    },
  }
);

// Export everything the same way for compatibility
export { supabase };
export const getSupabase = () => supabase;
export const createSupabaseClient = () => supabase;
export const initSupabase = () => supabase;
